import { IECommerceProduct } from 'shared/interfaces/ecommerce-product.interface';
import { http } from '../utils/axios';

class ProductService {
  private static instance: ProductService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): ProductService {
    if (!ProductService.instance) {
      ProductService.instance = new ProductService();
    }

    return ProductService.instance;
  }

  public getProductInfo = async ({ limit = 20, page = 1 }) => {
    const data = await http<{
      result: IECommerceProduct[];
      count: number;
    }>({
      url: '/ecommerceProducts',
      method: 'GET',
      params: {
        limit,
        page
      }
    });
    return data;
  };
  public createProduct = async (payload: any) => {
    //TCreateJourneyTemplate
    const { data } = await http<IECommerceProduct>({
      url: '/ecommerceProducts',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public getOneProduct = async (id: string) => {
    const { data } = await http<IECommerceProduct>({
      url: `/ecommerceProducts/${id}`,
      method: 'GET'
    });
    return data;
  };

  public updateProduct = async (payload: {
    id: string;
    data: IECommerceProduct;
  }) => {
    const { data } = await http<IECommerceProduct>({
      url: `/ecommerceProducts/${payload.id}`,
      method: 'PUT',
      data: payload.data
    });

    return data;
  };

  public getProductVariationsInfo = async ({
    limit = 20,
    page = 1,
    isMapped = undefined
  }) => {
    const data = await http<{
      result: IECommerceProduct[];
      count: number;
    }>({
      url: '/ecommerceProductVariations/mapping',
      method: 'GET',
      params: {
        limit,
        page,
        isMapped
      }
    });
    return data;
  };

  public mapEcommerceProductVariation = async (
    epvtId: string,
    payload: any
  ) => {
    const { data } = await http<any>({
      url: `/ecommerceProductVariations/${epvtId}/mapping`,
      method: 'POST',
      data: payload
    });

    return data;
  };
}

const instance = ProductService.getInstance();

export default instance;
